export function trackGAEvent(action, label) {
    // Check if gtag is available on the window object
    if (typeof window.gtag === 'function') {
        window.gtag('event', action, {
            'event_category': 'ButtonClick',
            'event_label': label
        });
    }
}
